import { gql } from "@apollo/client";

export const QUERY_FORM3457B_VERSION = gql`
  query studentForm3457B(
    $studentFormId: ID!
    $formId: ID!
    $studentId: ID!
    $schoolId: ID!
    $studentMeetingId: ID!
  ) {
    studentForm3457B(
      studentFormId: $studentFormId
      studentId: $studentId
      formId: $formId
      schoolId: $schoolId
      studentMeetingId: $studentMeetingId
    ) {
      versionId
      formId
      formDate
      studentFullName
      studentDob
      parent1
      parent2
      guardianInitialEvaluationConsent
      signatureDate
      formAction
      formStatus
    }
  }
`;
